import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAlldays } from "@/api/new-api/utility";

// Thunks

export const fetchAllDays = createAsyncThunk(
  "days/fetchAll",
  async (_, { rejectWithValue }) => {
    const res = await getAlldays();
    if (res.status === "success") return res.data.days;
    return rejectWithValue(res.message);
  }
);

// Initial State

const initialState = {
  days: [],
  getLoading: false,
  success: null,
  error: null,
  requestStatus: false,
};

// Slice

const daySlice = createSlice({
  name: "days",
  initialState,
  reducers: {
    clearDaysMessage: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchAllDays.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllDays.fulfilled, (state, action) => {
        state.getLoading = false;
        state.days = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchAllDays.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearDaysMessage } = daySlice.actions;
export default daySlice.reducer;
